import { DocumentNode } from 'graphql';
import { gql, MutationHookOptions, useMutation } from '@apollo/client';
import { IProductSchemaPartial } from '../../../type/product';

export interface IUnpublishProductDeveloperSchemaMarkupsMutationFields {
  productId: string;
  developerSchemaMarkupIds: string[];
}


export interface IUnpublishProductDeveloperSchemaMarkupsMutationResponseFields {
  updatedProduct: IProductSchemaPartial;
}


export function unpublishProductDeveloperSchemaMarkupsMutation(fragment: string): DocumentNode {
  return gql`
        mutation unpublishProductDeveloperSchemaMarkups (
        $productId: String!,
$developerSchemaMarkupIds: [String]!
        ) {
        unpublishProductDeveloperSchemaMarkups (
        productId: $productId,
developerSchemaMarkupIds: $developerSchemaMarkupIds
        ) {
        ...fragment
        }
        }
        fragment fragment on UnpublishProductDeveloperSchemaMarkupsMutationResponse {
        code
        success
        message
        ${fragment}
        }
    `;
}

export function useUnpublishProductDeveloperSchemaMarkupsMutation<TData extends Partial<IUnpublishProductDeveloperSchemaMarkupsMutationResponseFields>>(
  fragment: string, options?: MutationHookOptions<{ unpublishProductDeveloperSchemaMarkups: TData },
        IUnpublishProductDeveloperSchemaMarkupsMutationFields>,
) {
  return useMutation<{ unpublishProductDeveloperSchemaMarkups: TData },
      IUnpublishProductDeveloperSchemaMarkupsMutationFields>(
        unpublishProductDeveloperSchemaMarkupsMutation(fragment), options,
      );
}
